import { Box } from '@zillow/constellation-10';

import { useSelector } from '../../../../selectors/useSelector';
import { AppSelectors } from '../../../../selectors';

import MediumIllustrationHouse1x from '../../../../images/MediumIllustrationHouse@1x.png';
import MediumIllustrationHouse2x from '../../../../images/MediumIllustrationHouse@2x.png';
import { propertyPhotoStyles } from '../styles';

export const PropertyPhoto = () => {
  const photos = useSelector((state) => state.properties.currentProperty.photos);
  const primaryPhotoUrl = photos.length ? photos[0].url : null;

  const isScreenMobile = useSelector((state) => AppSelectors.makeIsScreenMobile(state));

  return (
    <Box
      css={{
        backgroundSize: primaryPhotoUrl
          ? 'cover'
          : {
              base: '70px',
              md: '105px',
            },
        ...propertyPhotoStyles,
      }}
      style={{
        backgroundImage: primaryPhotoUrl
          ? `url(${primaryPhotoUrl})`
          : isScreenMobile
            ? `url(${MediumIllustrationHouse2x})`
            : `url(${MediumIllustrationHouse1x})`,
      }}
    />
  );
};
